
import PublicService from "@/services/public.service";

/**
 * @classdesc Les champs du formulaire d'identité d'une inscription coureur
 * @kind class
 * @export
 * @prop {array} ids_parcours - Liste des ids des parcours selectionnés
 * @class List_Champs_Formulaire
 */
export default class List_Champs_Formulaire {
  list_ids_parcours = [];
  id_module;
  list = [];
  /**
   * Creates an instance of List_Champs_Formulaire.
   * @constructs
   * @kind function
   * @memberof List_Champs_Formulaire
   */
  constructor() { }

  async fetch(group_fields = false, billetterie = false) {

    let res = await PublicService.getChampsFormulaire(this.id_module);
    if (!res) return false;
    if (group_fields) {
      this.keepOnlyGroupeFields(res);
    }
    else {
      this.set(res, billetterie);
    }
    return true;

  }


  set(data, billetterie, hide_sexe_birthdate_fields = false) {
    this.list = this.buildListForParcours(data, this.list_ids_parcours, billetterie, hide_sexe_birthdate_fields);
  }

  /**
   * Retourne les noms de champs demandés pour une liste de parcours (même logique que set()).
   */
  static getChampNomsForParcours(champs_formulaire_store, list_ids_parcours, billetterie = false, hide_sexe_birthdate_fields = false) {
    const instance = new List_Champs_Formulaire();
    instance.list_ids_parcours = list_ids_parcours;
    const list = instance.buildListForParcours(
      champs_formulaire_store,
      list_ids_parcours,
      billetterie,
      hide_sexe_birthdate_fields
    );
    return new Set(list.map((champ) => champ.nom));
  }

  buildListForParcours(data, list_ids_parcours, billetterie, hide_sexe_birthdate_fields = false) {
    const list = [];
    let champs = data.list_generaux.concat(data.list_specifiques);

    const existInList = (id) => {
      for (let i = 0; i < list.length; i++) {
        if (list[i].id == id) {
          return i;
        }
      }
      return false;
    };

    for (let i = 0; i < data.list_liaisons_champs_course.length; i++) {
      let course = data.list_liaisons_champs_course[i];

      if (list_ids_parcours.includes(course.id_course)) {
        let champs_course = course.list_generaux.concat(course.list_specifiques);
        for (let j = 0; j < champs_course.length; j++) {
          if (champs_course[j].demande == "0") {
            continue;
          }
          let is_existing = existInList(champs_course[j].id_champ);
          if (!is_existing) {
            for (let k = 0; k < champs.length; k++) {
              if (champs[k].id == champs_course[j].id_champ) {
                champs[k].mandatory = champs_course[j].mandatory;
                list.push(champs[k]);
                break;
              }
            }
          }
          else {
            if (champs_course[j].mandatory > list[is_existing].mandatory) {
              list[is_existing].mandatory = champs_course[j].mandatory;
            }
          }
        }
      }
    }
    if (list.length == 0 && !billetterie) {
      for (let i = 0; i < data.list_generaux.length; i++) {
        if (data.list_generaux[i].mandatory == "1") {
          list.push(data.list_generaux[i]);
        }
      }
    }
    else if (list.length == 0 && billetterie) {
      let defaults = ["nom", "prenom", "sexe", "date_naissance", "mail", "telephone", "ville", "volvic_50"];
      for (let i = 0; i < data.list_generaux.length; i++) {
        if (defaults.includes(data.list_generaux[i].nom)) {
          if (hide_sexe_birthdate_fields && (data.list_generaux[i].nom == "sexe")) {
            continue;
          }
          list.push(data.list_generaux[i]);
        }
      }
    }
    return list;
  }

  set_default_mandatory_champs(data) {
    for (let i = 0; i < data.list_generaux.length; i++) {
      if (data.list_generaux[i].mandatory == "1") {
        this.list.push(data.list_generaux[i]);
      }
    }
  }

  set_default_champs(data, hide_sexe_birthdate_fields) {
    let defaults = ["nom", "prenom", "sexe", "date_naissance", "mail", "telephone", "ville", "volvic_50"];
    for (let i = 0; i < data.list_generaux.length; i++) {
      if (defaults.includes(data.list_generaux[i].nom)) {
        if (hide_sexe_birthdate_fields && (data.list_generaux[i].nom == "sexe")) {
          continue;
        }
        this.list.push(data.list_generaux[i]);
      }
    }
  }

  exist(id) {
    for (let i = 0; i < this.list.length; i++) {
      if (this.list[i].id == id) {
        return i;
      }
    }
    return false;
  }

  keepOnlyGroupeFields(data) {
    let fields_group = ["mail", "telephone", "club", "cp", "ville", "contact_urgence", "tel_contact_urgence"];
    let champs = data.list_generaux.concat(data.list_specifiques);
    for (let i = 0; i < champs.length; i++) {
      if (fields_group.includes(champs[i].nom)) {
        this.list.push(champs[i]);
      }
    }
  }
}